import React, { FC, memo } from 'react'
import { format } from '@dt/fe-utils'
import { decorationMobx } from '@mobxStore'

// props
interface IProps extends React.HTMLAttributes<HTMLDivElement> {
  /** 数据 */
  data: {
    /** 名称 */
    name: string;
    /** 加料no */
    no: string;
    /** j价格 */
    price: number;
    /** 售罄 */
    notSale?: boolean;
    /** icon */
    icon?: string;
    /** pic */
    pic?: string;
    /** disable */
    disable?: boolean;
    saleCnt?: number;
  };
  /** click事件 */
  onClick: (e: any) => void;
}

const SingleChooseItem: FC<IProps> = ({ data, className = '', onClick }) => {
  return (
    <div className={`${className}${data.notSale || data.disable ? ' disabled' : ''}`} data-cypid={`singleChooseItem${data.no || ''}`} onClick={(e) => onClick(e)}>
      {data.pic ? <img className='pic' src={data.pic} /> : null}
      {data.icon ? (<i className={`iconfont icon-${data.icon}`} />) : null}
      <span className='name'>{data.name}</span>
      {!data.notSale && <small className='price'>{data.price > 0 ? format.toPrice(data.price) : ''}</small>}
      {decorationMobx.mealDecorates.showSalesCnt && !data.notSale && data.saleCnt > 0 ? <span className='sub-price-limit'>{`(${i18n.t('cart.limit')}: ${data.saleCnt})`}</span> : null}
      {data.notSale && <span className='sub-price-limit'>{i18n.t('common.soldout')}</span>}
    </div>
  )
}

export default memo(SingleChooseItem)
